import { Component, createRef } from 'react';

// project imports
import Datatable from 'shared/datatable';
import {  getCaDetails, ccpaFileUpload, ccpafileUploadFragment, ccpadataUpdate } from 'shared/settings/apiconfig';
import {  getAdminUrl, getAdminHeaders, } from 'shared/http';
import { connect } from 'react-redux';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import DatePicker from "react-datepicker";
import { Modal, Spinner, Form, Row, Col, Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import { getBase64Content } from 'shared/utils/utils';
import './ComplianceOpen.scss';
import { capitalizeFirstLetter } from 'shared/utils';

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const SUPPORTED_FILE_PATTERN = /\.(xlsx|xls|csv|pdf|txt|jpg|jpeg|png|webp|heic|heif)$/i;

export class CompletedComplianceReport extends Component {

    config;
    initialSearchState;
    filterSearch;
    id;
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.id = '';
        this.initialSearchState = {
            email: { field: 'email', value: '', op: 'LIKE', join: 'AND' },
            firstname: { field: 'firstname', value: '', op: 'LIKE', join: 'AND' },
            lastname: { field: 'lastname', value: '', op: 'LIKE', join: 'AND' },
            phone: { field: 'phone', value: '', op: 'LIKE', join: 'AND' },
            starttime: { field: 'createdDate', value: '', op: '>=', join: 'AND' },
            endtime: { field: 'createdDate', value: '', op: '<=', join: 'AND' },
            status: { field: 'status', value: 'Open', op: '=', join: 'AND' },
            requestid: { field: 'requestid', value: '', op: 'LIKE', join: 'AND' },
        }
        this.state = {
            search: this.initialSearchState,
            statusFilter: 'all',
            searchData: false,
            tableData: [],
            buyerStatus: { value: '' },
            buyerToken: '',
            filterSearch: {},
            editModal: {
                show: false,
                data: null,
                files: [],
                actionTaken: '',
                status: '',
                loading: false,
                filePreviews: [],
                saveMessage: ''
            }
        }

        this.config = {
            name: 'openComplianceReport',
            url: getCaDetails,
            params: {},
            columns: [
                { name: 'Request ID', property: 'requestid', sort: false, width: '140px' },
                { name: 'First Name', property: 'firstname', sort: true, width: '160px' },
                { name: 'Last Name', property: 'lastname', sort: true, width: '160px' },
                { name: 'Phone', property: 'phone', sort: true, width: '160px' },
                { name: 'Date', property: 'createdDate', sort: true, width: '160px', columnType: 'custom', customColumn: this.customCreatedDate },
                { name: 'Email', property: 'email', sort: true, width: '130px' },
                { name: 'Address', property: 'address1', width: '180px', columnType: 'custom', customColumn: this.customAddress },
                { name: 'Type', property: 'righttype', width: '130px' },
                { name: 'Status', property: 'status', sortType: 'num', width: '50px', },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['edit'], customHeader: <> <div></div> </>, width: '150px',
                    actionEvents: {
                        edit: (row, state) => {
                            this.handleEditClick(row);
                        },
                    },
                },

            ],
            sort: [{ field: 'createdDate', direction: 'desc' }],
            pagination: true,
            field: ['firstname', 'lastname', 'email', 'address1', 'phone', 'takeaction', 'createdDate','expireDate', 'status', 'buyerid','file','actiontakennotes', 'righttype', '_id','city', 'state', 'zip', 'requestid'],
            adminUrl: {},
            ignoreRowBackground: true

        };

        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];
            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                if (temp['field'] === "createdDate" && temp['op'] === '>=') {
                    temp['value'] = new Date(temp['value']);
                    temp['field'] = 'starttime';
                }
                if (temp['field'] === "createdDate" && temp['op'] === '<=') {
                    temp['value'] = new Date(temp['value']);
                    temp['field'] = 'endtime';
                }

                tempSearch[temp['field']] = temp;
            });
            this.state['search'] = tempSearch;
            this.state['searchData'] = true;

        }

        this.dataTable = createRef();

    }


    componentDidMount() {
        if (!this.props?.location?.state?.datatable) {
            this.enableSearch()
        }
    }

    customDate = (value) => {
        if (value['modifieddate']) {
            return `${moment.utc(value['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    customAddress = (values) => {
        return (values['city'] ? values['city'] + ', ' : '') + (values['state'] ? values['state'] + ', ' : '') + (values['zip'] ? values['zip'] : '');
    }

    customCreatedDate = (value) => {
        if (value['createdDate']) {
            return `${moment.utc(value['createdDate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    customStatus = (value) => {
        if (value['status']) {
            return <span>{capitalizeFirstLetter(value['status'])}</span>
        }
        return '- - -';
    }

    enableSearch = () => {
        let search = {};
        let startDate = '';
        let endDate = '';

        if (this.state.search.starttime.value) {
            let startDateFormat = moment(this.state.search.starttime.value).format("YYYY-MM-DD")
            startDate = moment.tz(startDateFormat + ' 00:00:00', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
        } else if (this.state.isDateFromCheckBox) {
            startDate = this.state.checkedStartDateTime || '';
        }

        if (this.state.search.endtime.value) {
            let endDateformat = moment(this.state.search.endtime.value).format("YYYY-MM-DD")
            endDate = moment.tz(endDateformat + ' 23:59:59', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
        } else if (this.state.isDateFromCheckBox) {
            endDate = this.state.checkedEndDateTime || '';
        }

        const selectedStatus = this.state.statusFilter;
        const currentDate = moment().utc().format("YYYY-MM-DD hh:mm:ss");


        search = {
            email: { ...this.state.search.email, value: this.state.search.email.value ?  this.state.search.email.value  : '' },
            firstname: { ...this.state.search.firstname, value: this.state.search.firstname.value ? this.state.search.firstname.value : '' },
            lastname: { ...this.state.search.lastname, value: this.state.search.lastname.value ? this.state.search.lastname.value : '' },
            phone: { ...this.state.search.phone, value: this.state.search.phone.value ? this.state.search.phone.value : '' },
            starttime: { ...this.state.search.starttime, value: startDate || '' },
            endtime: { ...this.state.search.endtime, value: endDate || '' },
            requestid: { ...this.state.search.requestid, value: this.state.search.requestid.value ? this.state.search.requestid.value : '' },
            status: { field: "status", value: 'Open', op: "=", join: "AND" },
        }

        if (selectedStatus === 'Expired') {
            search.expireDate = { field: "expireDate", value: currentDate, op: "<", join: "AND" };
        }

        if (this.props?.location?.state) {
            this.setState({
                searchData: true
            })
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            checkedStartDateTime: '',
            checkedEndDateTime: '',
            statusFilter: 'all',
            filterSearch: this.initialSearchState,
        }, () => {
            this.enableSearch();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }
    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        const controlName = event.target.name;

        if (controlName === 'statusFilter') {
            this.setState({
                statusFilter: eventValue
            }, () => {
                this.enableSearch();
            });
            return;
        }

        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [controlName]: {
                    ...this.state.search[controlName],
                    value: eventValue
                }
            }
        }, () => {

        });
    }
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            issearch: true,
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            checkedStartDateTime: '',
            checkedEndDateTime: '',
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        });

    }

    // Handle edit button click
    handleEditClick = (row) => {
        this.setState({
            editModal: {
                ...this.state.editModal,
                show: true,
                data: row,
                actionTaken: row.actionTaken || '',
                status: row.status || '',
                files: [],
                filePreviews: [],
                saveMessage: ''
            }
        });
    }

    // Handle file selection (supports Excel, PDF, and images)
    handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files || []);
        if (!selectedFiles.length) return;

        const unsupportedFiles = selectedFiles.filter((file) => !SUPPORTED_FILE_PATTERN.test(file.name));
        const oversizedFiles = selectedFiles.filter((file) => file.size > MAX_FILE_SIZE);
        const validFiles = selectedFiles.filter((file) => (
            SUPPORTED_FILE_PATTERN.test(file.name) && file.size <= MAX_FILE_SIZE
        ));

        if (!validFiles.length) {
            const saveMessage = oversizedFiles.length
                ? 'Sorry failed to upload. Use a file of less than 10mb.'
                : 'Unsupported files are not allowed.';
            this.setState({
                editModal: { ...this.state.editModal, saveMessage }
            });
            event.target.value = '';
            return;
        }

        const existingFiles = this.state.editModal.files || [];
        const existingPreviews = this.state.editModal.filePreviews || [];
        const remainingSlots = Math.max(0, 10 - existingFiles.length);

        if (remainingSlots === 0) {
            this.setState({
                editModal: {
                    ...this.state.editModal,
                    saveMessage: 'Maximum 10 files are allowed.'
                }
            });
            event.target.value = '';
            return;
        }

        const filesToAdd = selectedFiles.slice(0, remainingSlots);
        const previewsToAdd = filesToAdd.map((file) => ({
            name: file.name,
            type: file.type,
            size: file.size,
            url: URL.createObjectURL(file)
        }));

        this.setState({
            editModal: {
                ...this.state.editModal,
                files: [...existingFiles, ...filesToAdd],
                filePreviews: [...existingPreviews, ...previewsToAdd],
                saveMessage: filesToAdd.length < selectedFiles.length ? 'Maximum 10 files are allowed.' : ''
            }
        });

        event.target.value = '';
    }
    createFileUrl = (fileDetail, key) => {
        // this is the standard url format used in backend(finally convert to base64)
        return btoa(
            "BIG" +
            fileDetail["filename"] +
            "$" +
            key +
            "$" +
            fileDetail["size"] +
            "$" +
            fileDetail["partCount"]
        );
    };


    // Handle action taken change
    handleActionTakenChange = (event) => {
        this.setState({
            editModal: {
                ...this.state.editModal,
                actionTaken: event.target.value,
                saveMessage: ''
            }
        });
    }

    getPreviewType = (fileType = '', fileName = '') => {
        const normalizedType = (fileType || '').toLowerCase();
        const normalizedName = (fileName || '').toLowerCase();

        // Image types
        if (normalizedType.startsWith('image/')) {
            // Some browsers report HEIC/HEIF as image/heic or image/heif
            if (normalizedType === 'image/heic' || normalizedType === 'image/heif') {
                return 'image';
            }

            // Regular images
            return 'image';
        }

        // Fallback for HEIC/HEIF when MIME type is unreliable
        if (normalizedName.endsWith('.heic') || normalizedName.endsWith('.heif')) {
            return 'image';
        }

        if (normalizedType === 'application/pdf') {
            return 'pdf';
        }
        if (normalizedType === 'application/csv' || normalizedType === 'text/csv') {
            return 'file';
        }
        if (normalizedType.startsWith('text/') || normalizedType === 'application/json') {
            return 'text';
        }
        return 'file';
    }

    // Handle status change
    handleStatusChange = (event) => {
        this.setState({
            editModal: {
                ...this.state.editModal,
                status: event.target.value,
                saveMessage: ''
            }
        });
    }

    // Remove file
    removeFile = (index) => {
        const newFiles = this.state.editModal.files.filter((_, i) => i !== index);
        const newPreviews = this.state.editModal.filePreviews.filter((_, i) => i !== index);

        const removedPreview = this.state.editModal.filePreviews[index];
        if (removedPreview?.url) {
            URL.revokeObjectURL(removedPreview.url);
        }

        this.setState({
            editModal: {
                ...this.state.editModal,
                files: newFiles,
                filePreviews: newPreviews,
                saveMessage: ''
            }
        });
    }

    openFileInNewTab = (url) => {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    uploadSingleComplianceFile = async (media) => {
        const fileName = media.name;
        const fileSize = media.size;

        let offset = 0;
        let chunkCount = 0;
        const chunkSize = Math.ceil(1024 * 1024 * 1);
        const totalChunks = Math.ceil(fileSize / chunkSize, chunkSize);

        const data = {
            filename: fileName,
            size: fileSize,
            partCount: totalChunks,
        };

        let response = await axios.post(getAdminUrl(ccpaFileUpload), JSON.stringify({ data: data }), getAdminHeaders());
        if (response.data.status !== 'success') {
            throw new Error('Failed to initialize file upload');
        }

        const partKey = response.data.partkey;
        const fileUrl = this.createFileUrl(data, partKey);

        while (chunkCount < totalChunks) {
            offset = chunkCount * chunkSize;
            const chunkFile = media.slice(offset, offset + chunkSize);

            const fragmentData = {
                partkey: partKey,
                partid: chunkCount + 1,
                content: await getBase64Content(chunkFile),
            };
            response = await axios.post(getAdminUrl(ccpafileUploadFragment), { data: fragmentData }, getAdminHeaders());

            chunkCount++;
        }

        return { fileUrl, fileName };
    }

   handleSave = async () => {
        const { editModal } = this.state;

        if (this.isSaveDisabled()) {
            return;
        }
        this.setState({
            editModal: {
                ...this.state.editModal,
                loading: true
            }
        });
        let fileUrls = [];
        let fileNames = [];
        try {
            const mediaFiles = Array.isArray(editModal.files) ? editModal.files : [];
            if (mediaFiles.length) {
                const uploadedFiles = await Promise.all(mediaFiles.map((media) => this.uploadSingleComplianceFile(media)));
                fileUrls = uploadedFiles.map((item) => item.fileUrl).filter(Boolean);
                fileNames = uploadedFiles.map((item) => item.fileName).filter(Boolean);
            }
        } catch (error) {
            this.setState({
                editModal: {
                    ...this.state.editModal,
                    loading: false,
                    saveMessage: 'Upload failed. Please try again.'
                }
            });
            return;
        }
        const filePayload = fileUrls.map((hash, index) => ({
            name: fileNames[index] || '',
            hash,
        })).filter((item) => item.hash);

        let data = {
            _id: editModal.data._id,
            file: filePayload,
            status: editModal.status ? editModal.status : '',
            actiontakennotes : editModal.actionTaken
        };

        axios.put(getAdminUrl(ccpadataUpdate), JSON.stringify({ data: data }), getAdminHeaders()).then(response => {
            if (response.data.status === 'success') {
                this.setState({
                    editModal: {
                        ...this.state.editModal,
                        loading: false,
                        files: [],
                        filePreviews: [],
                        saveMessage: 'Saved'
                    }
                }, () => {
                   setTimeout(() => {
                        this.handleCancel();
                    }, 1000);
                });
                this.dataTable.current.searchData();
            }
        }).catch(error => {
            this.setState({
                editModal: {
                    ...this.state.editModal,
                    loading: false,
                    files: [],
                    filePreviews: [],
                    saveMessage: ''
                }
            });
        });
    }

      onChangeCheckBox = (event) => {
            if (this.state.isActiveCheckbox === event) {
                this.setState({
                    isActiveCheckbox: '',
                    isDateFromCheckBox: false,
                    checkedStartDateTime: '',
                    checkedEndDateTime: ''
                }, this.enableSearch);
                return;
            }

            let starttime = '';
            let endtime = '';
            if (event == "yesterday") {
                let yesterday = moment().tz('US/Eastern').subtract(1, 'day');
                starttime = yesterday.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
                endtime = yesterday.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            } else if (event == "week") {
                let dateTime = moment().tz('US/Eastern');
                starttime = dateTime.clone().startOf('isoWeek').utc().format('YYYY-MM-DD HH:mm:ss');
                endtime = dateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            } else if (event == "month") {
                let dateTime = moment().tz('US/Eastern');
                starttime = dateTime.clone().startOf('month').utc().format('YYYY-MM-DD HH:mm:ss');
                endtime = dateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            } else if (event == "year") {
                let dateTime = moment().tz('US/Eastern');
                starttime = dateTime.clone().startOf('year').utc().format('YYYY-MM-DD HH:mm:ss');
                endtime = dateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            } else if (event == "last_7days") {
                let startDateTime = moment().tz('US/Eastern').subtract(7, 'days');
                let endDateTime = moment().tz('US/Eastern').subtract(1, 'day');
                starttime = startDateTime.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
                endtime = endDateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            } else if (event == "last_30days") {
                let startDateTime = moment().tz('US/Eastern').subtract(30, 'days');
                let endDateTime = moment().tz('US/Eastern').subtract(1, 'day');
                starttime = startDateTime.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
                endtime = endDateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            } else if (event == "last_365days") {
                let startDateTime = moment().tz('US/Eastern').subtract(365, 'days');
                let endDateTime = moment().tz('US/Eastern').subtract(1, 'day');
                starttime = startDateTime.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
                endtime = endDateTime.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
            } 
    
            
                this.setState({
                    isActiveCheckbox: event,
                    isDateFromCheckBox: true,
                    checkedStartDateTime: starttime,
                    checkedEndDateTime: endtime
                }, () => {
                    this.setState({
                        ...this.state,
                        issearch: true,
                        locationcheck: false,
                        dateErrormsg:'',
                        search: {
                            ...this.state.search,
                            starttime: {
                                ...this.state.search['starttime'],
                                value: ''
                            },
                            endtime: {
                                ...this.state.search['endtime'],
                                value: ''
                            }
                        },
                        startDate: '',
                        endDate: '',
                        monthDropdownValue: ''
                    }, () => {
                       this.enableSearch()
                    })
                })
            
        }

    isSaveDisabled = () => {
        const { status, actionTaken, files, loading } = this.state.editModal;
        const notes = (actionTaken || '').trim();

        if (loading) {
            return true;
        }

        if (!status) {
            return true;
        }

        if (status === 'Closed' || status === 'Rejected') {
            return !notes || files.length === 0;
        }

        if (status === 'Resolved') {
            return !notes;
        }

        return true;
    }

    // Handle cancel action
    handleCancel = () => {
        this.state.editModal.filePreviews.forEach(preview => {
            if (preview?.url) {
                URL.revokeObjectURL(preview.url);
            }
        });

        this.setState({
            editModal: {
                show: false,
                data: null,
                files: [],
                actionTaken: '',
                status: '',
                loading: false,
                filePreviews: [],
                saveMessage: ''
            }
        });
    }

    render() {

        return (
            <div className="compliance-open">
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">

                                <Row>
                                 
                                    <Col>
                                        <label>Request ID</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="requestid" value={this.state.search.requestid.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                       <Col>
                                        <label>Email</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="email" value={this.state.search.email.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>First Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="firstname" value={this.state.search.firstname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>Last Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="lastname" value={this.state.search.lastname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                 
                                    

                                </Row>
                                 <Row>
                                      <Col>
                                        <label>Phone</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="phone" value={this.state.search.phone.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                            
                                    <Col>
                                        <label
                                            className="d-flex align-items-center"
                                            style={{ width: '100%', marginBottom: 0 }}
                                        >
                                            <span>Status {" "}</span>

                                            <div className="ms-auto d-flex align-items-center w-100" style={{marginLeft: '10px' }}>
                                                <OverlayTrigger
                                                    trigger={['hover', 'focus']}
                                                    overlay={
                                                    <Tooltip id="tooltip-clone" style={{ visibility: 'visible' }} placement="right">
                                                        <div style={{ textAlign: 'left' }}>
                                                            <span style={{ fontWeight: 'bold' }}>Open:</span> Shows all records.
                                                        </div>
                                                        <div style={{ textAlign: 'left' }}>
                                                            <span style={{ fontWeight: 'bold' }}>SLA Breach:</span> Shows records older than 44 days.
                                                        </div>
                                                    </Tooltip>
                                                    }
                                                >
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                            </div>
                                        </label>

                                        <Form.Control
                                            as="select"
                                            name="statusFilter"
                                            value={this.state.statusFilter}
                                            onChange={this.searchInputChange}
                                        >
                                            <option value="Open">Open</option>
                                            <option value="Expired">SLA Breach</option>
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label> Date From</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#959393" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Date To</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#959393" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>

                                   
                                </Row>

                                <Row className='checkbox-resp' style={{ width: '100%' }}>
                                    <div className='d-flex wt-50'>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'yesterday' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('yesterday')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Yesterday</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Yesterday'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'week' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('week')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Week to Date</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Monday to today of current week'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                    <div className='d-flex wt-50'>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'month' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('month')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Month to Date</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current month to current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'year' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('year')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Year to Date</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current year to current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                </Row>

                                <Row className='checkbox-resp' style={{ width: '100%' }}>
                                    <div className='d-flex wt-50'>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_7days' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_7days')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Last 7 days</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 7 days excluding current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_30days' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_30days')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Last 30 days</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 30 days excluding current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                    <div className='d-flex wt-50'>
                                        <Col>
                                            <div className={`d-flex align-items-center header`}>
                                                <div style={{ marginLeft: '10px' }}>
                                                    <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_365days' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_365days')}></div>
                                                </div>
                                                <div style={{ marginLeft: '5%' }}>
                                                    <div className='text-nowrap'>Last 365 days</div>
                                                </div>
                                                <div style={{ marginLeft: '4%', marginTop: '1.5px' }}>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 365 days excluding current date'}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col></Col>
                                    </div>
                                </Row>  
                                



                                        <div className="mt-3 mt-3 d-flex justify-content-end ">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="search-button" onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                            </div>
                        </Form>

                    </div>
                </div>
                <div className="buyer-table">
                    <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable}
                        onDataUpdate={this.updateTableData} />
                </div>

                {/* Edit Modal for Duplicate Address */}
                <Modal
                    show={this.state.editModal.show}
                    onHide={this.handleCancel}
                    size="lg"
                    backdrop="static"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Compliance Action</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="compliance-open-modal">
                        <Form>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='text-bold'>Upload Evidence{this.state.editModal.status !== 'Resolved' && <span className="required"></span>}</Form.Label>
                                        <div className="border rounded p-4" style={{ minHeight: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            <div
                                                className="mb-3"
                                                style={{
                                                    width: '100%',
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
                                                    gap: '12px'
                                                }}
                                            >
                                                {this.state.editModal.filePreviews.map((preview, index) => (
                                                    <div key={index} className="position-relative" style={{ minWidth: 0 }}>
                                                        {/\.(heic|heif)$/i.test((preview.name || '').toLowerCase()) ? (
                                                            <div className="border p-2 d-flex align-items-center justify-content-center" style={{ width: '100%', height: '100px' }}>
                                                                <div className="text-center">
                                                                    <i className="fa fa-file text-muted" style={{ fontSize: '24px' }}></i>
                                                                    <div className="mt-1" style={{ fontSize: '10px', wordBreak: 'break-word' }}>
                                                                        {preview.name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            this.getPreviewType(preview.type) === 'image' && (
                                                                <Image
                                                                    src={preview.url}
                                                                    alt={`Preview ${index + 1}`}
                                                                    style={{ width: '100%', height: '100px', objectFit: 'cover' }}
                                                                    className="border"
                                                                />
                                                            )
                                                        )}

                                                        {this.getPreviewType(preview.type) === 'pdf' && (
                                                            <embed
                                                                src={preview.url}
                                                                type="application/pdf"
                                                                style={{ width: '100%', height: '100px' }}
                                                                className="border"
                                                            />
                                                        )}

                                                        {this.getPreviewType(preview.type) === 'text' && (
                                                            <iframe
                                                                src={preview.url}
                                                                title={`Preview ${index + 1}`}
                                                                style={{ width: '100%', height: '100px', border: '1px solid #dee2e6' }}
                                                            />
                                                        )}

                                                        {this.getPreviewType(preview.type) === 'file' && (
                                                            <div className="border p-2 d-flex align-items-center justify-content-center" style={{ width: '100%', height: '100px' }}>
                                                                <div className="text-center">
                                                                    <i className="fa fa-file text-muted" style={{ fontSize: '24px' }}></i>
                                                                    <div className="mt-1" style={{ fontSize: '10px', wordBreak: 'break-word' }}>
                                                                        {preview.name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <Button
                                                            variant="info"
                                                            size="sm"
                                                            className="position-absolute"
                                                            style={{ top: '-10px', right: '22px', color: '#fff' }}
                                                            onClick={() => this.openFileInNewTab(preview.url)}
                                                            disabled={this.state.editModal.loading}
                                                            title="View"
                                                        >
                                                            <i className="fa fa-eye"></i>
                                                        </Button>

                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            className="position-absolute"
                                                            style={{ top: '-10px', right: '-10px' }}
                                                            onClick={() => this.removeFile(index)}
                                                            disabled={this.state.editModal.loading}
                                                        >
                                                            ×
                                                        </Button>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="text-center">
                                                <Button
                                                    variant="secondary"
                                                    onClick={() => document.getElementById('file-upload-input').click()}
                                                >
                                                    Choose Files
                                                </Button>
                                                <Form.Control
                                                    id="file-upload-input"
                                                    type="file"
                                                    accept=".xlsx,.xls,.csv,.pdf,.txt,image/*,.heic,.heif"
                                                    multiple
                                                    onChange={this.handleFileChange}
                                                    style={{ display: 'none' }}
                                                />
                                                <div className="text-muted mt-2">Supports up to 10 files: Excel, CSV, PDF, TXT, or image</div>
                                            </div>
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="text-bold">Action Taken / Notes <span className="required"></span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            value={this.state.editModal.actionTaken}
                                            onChange={this.handleActionTakenChange}
                                            placeholder="Enter action taken or notes..."
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="text-bold">Status <span className="required"></span></Form.Label>
                                        <div className="d-flex flex-row gap-4">
                                            <Form.Check
                                                type="radio"
                                                id="status-rejected"
                                                label="Rejected"
                                                name="status"
                                                value="Rejected"
                                                checked={this.state.editModal.status === 'Rejected'}
                                                onChange={this.handleStatusChange}
                                            />
                                            <Form.Check style={{ marginLeft: '20px' }}
                                                type="radio"
                                                id="status-resolved"
                                                label="Resolved"
                                                name="status"
                                                value="Resolved"
                                                checked={this.state.editModal.status === 'Resolved'}
                                                onChange={this.handleStatusChange}
                                            />
                                            <Form.Check style={{ marginLeft: '20px' }}
                                                type="radio"
                                                id="status-closed"
                                                label="Closed"
                                                name="status"
                                                value="Closed"
                                                checked={this.state.editModal.status === 'Closed'}
                                                onChange={this.handleStatusChange}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center flex-column">
                        {this.state.editModal.saveMessage && (
                            <div className={`${this.state.editModal.saveMessage === 'Saved' ? 'text-success' : 'text-danger'} fw-bold mb-2`}>
                                {this.state.editModal.saveMessage}
                            </div>
                        )}
                        <div className="d-flex justify-content-center">
                        <Button variant="secondary mx-3" onClick={this.handleCancel} disabled={this.state.editModal.loading}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.handleSave}
                            disabled={this.isSaveDisabled()}
                        >Save
                            {this.state.editModal.loading &&
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />}
                        </Button>
                        </div>
                    </Modal.Footer>
                </Modal>


            </div>
        );
    }
}
export default connect(state => state)(CompletedComplianceReport);
